import React from 'react';
import { useHistory } from 'react-router-dom';
import { ImageReservationNumber } from '../../assets/images';
import './CancelPanel.scss';
import { AppRoutes } from '../../routes';
import { TranslationUtils } from '../../utils';

export const CancelPanel: React.FC = () => {
    const history = useHistory();

    return (
        <div className="cancel-panel">
            <div className="cancel-image">
                <ImageReservationNumber className="d-none d-md-block" />
            </div>
            <div tabIndex={0} className="cancel-text">
                <h6 className="body-bold">{TranslationUtils.get('need_cancel_trip')}</h6>
                <a
                    className="body-xs"
                    tabIndex={0}
                    role="button"
                    id="link-navigation-modify-trip"
                    onClick={() => history.push(AppRoutes.CANCEL)}
                    onKeyPress={() => history.push(AppRoutes.CANCEL)}
                >
                    {TranslationUtils.get('cancel_trip_options')}
                </a>
            </div>
        </div>
    );
};
